module.exports = __webpack_public_path__ + "img/tap_deck_header_spanish.4b65989b.png";